var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{class:{ 'page-header': true, 'page-header-collapsed': _vm.collapsed }},[_c('div',{staticClass:"page-title-wrapper"},[_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.$route.meta.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }